<template>
    <div class="projects-operations">

        <div class="content">

            <content-switch
            :items="switchItems"
            :selectedItem="selectedItem"
            :counts="counts"
            @selectItem="handleSelectItem($event)" />

            <openProjects-table v-show="selectedItem === 'openProjects'" @finishedLoading="updateCount('openProjects', $event)" />
            <snoozedProjects-table v-show="selectedItem === 'snoozedProjects'" @finishedLoading="updateCount('snoozedProjects', $event)" />
            <noInvoiceProjects-table v-show="selectedItem === 'noInvoiceProjects'" @finishedLoading="updateCount('noInvoiceProjects', $event)" />
            <ongoingProjects-table v-show="selectedItem === 'ongoingProjects'"  @finishedLoading="updateCount('ongoingProjects', $event)" />
            <claimsProjects-table v-show="selectedItem === 'openClaims'" @finishedLoading="updateCount('openClaims', $event)" />
            <coming-soon v-show="selectedItem === 'projectsCloseToBudget'" />

        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            selectedItem: 'openProjects',
            counts: {
                openProjects: null,
                snoozedProjects: null,
                noInvoiceProjects: null,
                ongoingProjects: null,
                openClaims: null,
                projectsCloseToBudget: '-'
            },
            switchItems: [
                {
                    name: 'Ikke igangsatte opgaver',
                    slug: 'openProjects'
                },
                {
                    name: 'Opgaver uden bevægelse i ' + this.$store.state.config.companyMeta.settings.snoozed_days + ' dage',
                    slug: 'snoozedProjects'
                },
                {
                    name: 'Afsluttede opgaver, der ikke er fakturerede',
                    slug: 'noInvoiceProjects'
                },
                {
                    name: 'Igangværende opgaver',
                    slug: 'ongoingProjects'
                },
                {
                    name: 'Igangværende reklamationer',
                    slug: 'openClaims'
                }
                /* {
                    name: 'Opgaver der har nået 80% af budget',
                    tableName: 'projectsCloseToBudget'
                } */
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
        }
    },
    mounted () {
        this.$store.state.view = 'operations'
    }
}
</script>



// WEBPACK FOOTER //
// operations.vue?1b313665